import Bugsnag from '@bugsnag/js';
import { PHASE_PRODUCTION_BUILD } from 'next/constants';

const IGNORED_ERRORS = [
  'Failed to load https://www.googletagmanager.com/gtag/',
];

export function startBugsnag() {
  if (process.env.NEXT_PHASE !== PHASE_PRODUCTION_BUILD) {
    Bugsnag.start({
      apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY as string,
      appVersion: process.env.NEXT_BUILD_ID,
      autoDetectErrors: true,
      onError: event => {
        const { originalError } = event;
        const ignored = IGNORED_ERRORS.some(
          msg =>
            originalError &&
            originalError.message &&
            originalError.message.includes(msg)
        );
        if (ignored) {
          return false;
        }
      },
    });
  }
}
